import artifactServices from "./artifact";
import notableServices from "./notable";
import eventServices from "./event";
import documentServices from "./document";
import extraServices from "./extra";
import categoryServices from "./category";
import configServices from "./config";
import tagServices from "./tag"

function list(type, params) {
  if (type === "artifacts") {
    return artifactServices.list(params);
  }
  if (type === "notables") {
    return notableServices.list(params);
  }
  if (type === "documents") {
    return documentServices.list(params);
  }
  if (type === "events") {
    return eventServices.list(params);
  }
  if (type === "categories") {
    return categoryServices.list(params);
  }
  if (type === "extras") {
    return extraServices.list(params);
  }
  if (type === "config") {
    return configServices.list(params);
  }
  if (type === "tags") {
    return tagServices.list(params);
  }
  return () => {};
}

function show(type, id) {
  if (type === "artifacts") {
    return artifactServices.show(id);
  }
  if (type === "categories") {
    return categoryServices.show(id);
  }
  if (type === "documents") {
    return documentServices.show(id);
  }
  if (type === "events") {
    return eventServices.show(id);
  }
  if (type === "notables") {
    return notableServices.show(id);
  }
  if (type === "extras") {
    return extraServices.show(id);
  }
  if (type === "config") {
    return configServices.show(id);
  }
  return () => {};
}

function create(type, data) {
  if (type === "artifacts") {
    return artifactServices.create(data);
  }
  if (type === "categories") {
    return categoryServices.create(data);
  }
  if (type === "documents") {
    return documentServices.create(data);
  }
  if (type === "events") {
    return eventServices.create(data);
  }
  if (type === "notables") {
    return notableServices.create(data);
  }
  if (type === "extras") {
    return extraServices.create(data);
  }
  if (type === "config") {
    return configServices.create(data);
  }
  return () => {};
}

function update(type, data) {
  if (type === "artifacts") {
    return artifactServices.update(data);
  }
  if (type === "categories") {
    return categoryServices.update(data);
  }
  if (type === "documents") {
    return documentServices.update(data);
  }
  if (type === "events") {
    return eventServices.update(data);
  }
  if (type === "notables") {
    return notableServices.update(data);
  }
  if (type === "extras") {
    return extraServices.update(data);
  }
  if (type === "config") {
    return configServices.update(data);
  }
  return () => {};
}

function updateMultiple(type, data) {
  if (type === "artifacts") {
    return artifactServices.updateMultiple(data);
  }
  if (type === "categories") {
    return categoryServices.updateMultiple(data);
  }
  if (type === "documents") {
    return documentServices.updateMultiple(data);
  }
  if (type === "events") {
    return eventServices.updateMultiple(data);
  }
  if (type === "notables") {
    return notableServices.updateMultiple(data);
  }
  if (type === "extras") {
    return extraServices.updateMultiple(data);
  }
  return () => { };
}

function remove(type, data) {
  if (type === "artifacts") {
    return artifactServices.remove(data);
  }
  if (type === "categories") {
    return categoryServices.remove(data);
  }
  if (type === "documents") {
    return documentServices.remove(data);
  }
  if (type === "events") {
    return eventServices.remove(data);
  }
  if (type === "notables") {
    return notableServices.remove(data);
  }
  if (type === "extras") {
    return extraServices.remove(data);
  }
  if (type === "config") {
    return configServices.remove(data);
  }
  return () => {};
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
